import { withViewModel } from '../../../infrastructure/components/with-view-model';
import { EmailTemplateFormPresentation } from './email-templates-form-presentation';
import { EmailTemplatesFormVM } from './email-templates-form.viewmodel';

interface IProps {
    saveCompletedCallback: () => Promise<void>;
    deleteCompletedCallback: (id: string) => void;
    accountId: number;
    emailTemplateId?: string;
}

export const EmailTemplateForm = withViewModel(EmailTemplateFormPresentation, async (props: IProps) => {
    const vm = new EmailTemplatesFormVM(
        props.accountId,
        props.saveCompletedCallback,
        props.deleteCompletedCallback,
        props.emailTemplateId,
    );
    await vm.initialize();
    return vm;
});
